import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  Box,
  Avatar,
} from "@mui/material";
import { useState } from "react";
import Searchicon from "../../../../assets/setting/rolsAndpermissions/Searchicon.svg";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { profileData } from "../../../../mock-data/role-and-permission/add-employee-list";
import "./permissiongroup.scss";

const EmployListModal = (props: any) => {
  const [selectUser, setSelectUser] = useState<any>([]);
  const [allUsers, setAllUsers] = useState<any>(profileData);

  const handleSelectFunc = (profileInfo: any) => {
    const checkUser = selectUser.find(
      (user: any) => user.id === profileInfo.id
    );
    if (!checkUser) {
      setSelectUser([...selectUser, profileInfo]);
    }
  };

  const handleSelectDeselet = (type: string) => {
    if (type === "select all") {
      setSelectUser(profileData);
    } else {
      setSelectUser([]);
    }
  };

  return (
    <div className="EmplpyeListModal_main">
      <Dialog
        className="Mian_dialog"
        maxWidth="md"
        open={props.open}
        onClose={props.close}
        PaperProps={{
          style: {
            backgroundColor: "#fff",
            borderRadius: "12px",
            width: "720px",
            boxShadow: "-8px 8px 12px rgba(76, 0, 39, 0.15)",
          },
        }}
      >
        <DialogTitle
          className="dialpg_title"
          sx={{ backgroundColor: "rgba(247, 136, 18, 0.05)" }}
        >
          Select Employees
        </DialogTitle>

        <DialogContent sx={{ padding: "30px 40px 20px 40px !important" }}>
          <div className="sidebye_Employee_main_wraper">
            <div className="input_wrpaer">
              <input type="text" className="input" />
              <img src={Searchicon} alt="icon" />
            </div>
            <Grid container spacing={2}>
              {/* left side */}
              <Grid item xs={12} sm={12} md={6}>
                <Box
                  sx={{
                    border: "1px solid #CCCCCC ",
                    borderRadius: "5px",
                    height: "360px",
                    "& ::-webkit-scrollbar": {
                      width: "0px",
                    },
                  }}
                  className="All_employe_list"
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      padding: "10px 20px",
                    }}
                  >
                    <button
                      className="btn btn-text-danger"
                      onClick={() => handleSelectDeselet("select all")}
                    >
                      Select All
                    </button>
                  </Box>

                  <Box sx={{ height: "249px", overflow: "auto" }}>
                    {allUsers.map((profileInfo: any) => (
                      <Box
                        key={profileInfo.id}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "0 20px",
                          margin: "15px 0",
                          cursor: "pointer",
                        }}
                        onClick={() => handleSelectFunc(profileInfo)}
                      >
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Avatar
                            alt="Profile Imag"
                            src={profileInfo.image}
                            sx={{ width: 32, height: 32, marginRight: "10px" }}
                          />
                          <Box sx={{ color: "#14142B" }}>
                            {profileInfo.name}
                          </Box>
                        </Box>
                        <span>
                          <ArrowForwardIosIcon
                            sx={{ fontSize: "12px", color: "#14142B" }}
                          />
                        </span>
                      </Box>
                    ))}
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start ",
                      padding: "10px 20px",
                    }}
                  >
                    Total: {allUsers.length}
                  </Box>
                </Box>
              </Grid>
              {/* right side */}
              <Grid item xs={12} sm={12} md={6}>
                <Box
                  sx={{
                    border: "1px solid #CCCCCC ",
                    borderRadius: "5px",
                    height: "360px",
                    "& ::-webkit-scrollbar": {
                      width: "0px",
                    },
                  }}
                  className="All_employe_list"
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      padding: "10px 20px",
                    }}
                  >
                    <button
                      className="btn btn-text-danger"
                      onClick={() => handleSelectDeselet("deselect all")}
                    >
                      Deselect
                    </button>
                  </Box>
                  <Box sx={{ height: "249px", overflow: "auto" }}>
                    {selectUser.map((user: any) => (
                      <Box
                        key={user.id}
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "10px 20px",
                        }}
                      >
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <Avatar
                            alt="Profile Imag"
                            src={user.image}
                            sx={{ width: 32, height: 32, marginRight: "10px" }}
                          />
                          <Box sx={{ color: "#14142B" }}>{user.name}</Box>
                        </Box>
                        <span>
                          <ArrowForwardIosIcon
                            sx={{ fontSize: "12px", color: "#14142B" }}
                          />
                        </span>
                      </Box>
                    ))}
                  </Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-start ",
                      padding: "10px 20px",
                    }}
                  >
                    Total: {selectUser.length}
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </div>
        </DialogContent>
        <DialogActions sx={{ padding: "20px 40px 30px 40px" }}>
          <button className="btn btn-disabled" onClick={props.close}>
            Cancel
          </button>
          <button
            className="btn btn-secondary "
            onClick={() => {
              props.getFinalUsers(selectUser);
              props.close();
            }}
          >
            Add
          </button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
export default EmployListModal;